export default {
  name: '현재 개인정보처리방침 (2025.12.11)',
  html: `
<div>
  <p class="policy-index" data-index="0" data-label="개인정보의 처리목적">
    <i>1</i> 개인정보의 처리목적
  </p>
  <div class="policy-content">
<pre>
전남드래곤즈 홈페이지는 회원가입 시 서비스 이용을 위해 필요한 최소한의 개인정보만을 수집합니다.
처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행 할 예정입니다.

홈페이지 회원가입 및 관리
귀하가 전남드래곤즈 홈페이지의 서비스를 이용하기 위해서는 회원가입시 본인인증을 통한 성명, 휴대폰번호, 생년월일, 성별, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI)와 직접 입력하는 아이디, 비밀번호, 이메일 주소 항목을 필수로로 입력하셔야 합니다. 회원가입시 선택 입력항목이 없습니다.
- 아이디, 비밀번호, 성명, 휴대폰번호, 생년월일, 성별, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI) : 회원제 서비스 이용에 따른 본인 식별 절차에 이용
- 이메일주소, 휴대폰번호 : 공지사항 전달, 개인맞춤 서비스, 경품 배송 등을 위한 원활한 의사소통 경로의 확보 등의 안내

시즌권등록 관리
: 시즌권 혜택 제공을 위한 식별 절차 및 의사소통 경로

티켓, 시즌권 구매관리
: 티켓 구매 및 관련 서비스의 제공을 위한 개인 식별 절차 및 의사소통 경로
</pre>
  </div>
  <p class="policy-index" data-index="1" data-label="처리하는 개인정보의 항목">
    <i>2</i> 처리하는 개인정보의 항목
  </p>
  <div class="policy-content">
<pre>
회사는 다음의 개인정보 항목을 처리하고 있습니다.

홈페이지 회원가입 및 관리
- 필수항목 : 아이디, 비밀빌번호, 성명, 생년월일, 성별, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI), 휴대폰번호, 이메일 주소
- 선택항목 : 해당 사항 없음

시즌권등록 관리
- 필수항목 : 실사용자 이름, 시즌권번호, 실사용자 본인 여부, 실사용자 휴대폰번호, 실사용자 이메일 주소 입력, 주소 입력
- 선택항목 : 해당 사항 없음

티켓, 시즌권 구매관리
- 필수항목 : 이름, 생년월일, 연락처, 이메일
- 선택항목 : 해당 사항 없음

회원 공통
- 자동수집정보(필수) : 서비스 이용기록, 접속로그, 쿠키, 접속 IP 주소, MAC 주소, 방문일시, 불량이용기록
</pre>
  </div>
  <p class="policy-index" data-index="2" data-label="정보주체와 법정대리인의 권리·의무 및 행사방법">
    <i>3</i> 정보주체와 법정대리인의 권리·의무 및 행사방법
  </p>
  <div class="policy-content">
<pre>
귀하는 언제든지 등록되어 있는 귀하의 개인정보를 열람하거나 정정하실 수 있습니다. 개인정보 열람 및 정정을 하고자 할 경우에는 로그인 후 '개인정보수정'을 클릭하여 직접 열람 또는 정정하거나, 개인정보관리책임자에게 서면, 유선, 이메일 등으로 연락하시면 즉시 조치하겠습니다.

귀하가 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 당해 개인정보를 이용하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 조치하겠습니다.

정보주체의 열람·정정·삭제·처리정지 요구 거절 시 불복을 위한 이의제기 절차는 다음과 같습니다.
① 개인정보 관리부서에서 열람 등 요구에 대한 연기 또는 거절 시 요구받은 날로부터 10일 이내에 정당한 사유 및 이의제기 방법 등을 통지
② 개인정보 관리부서에서 정보주체의 이의제기 신청 및 접수(서면, 유선, 이메일) 개인정보 담당자가 내용 확인
③ 개인정보 관리책임자가 처리결과에 대해 최종 검토
④ 개인정보 관리부서에서 정보주체에게 처리결과 통보

회원가입 등을 통해 이루어진 개인정보의 수집, 이용, 제공에 대해 귀하께서 동의하신 내용을 귀하는 언제든지 철회하실 수 있습니다. 동의철회는 홈페이지 로그인 후 마이페이지 내 회원탈퇴를 통해서 동의철회가 가능합니다. 개인정보관리책임자에게 서면, 전화, 이메일 등으로 연락하시면 회원가입을 제외한 개인정보의 삭제 등 필요한 조치를 취하겠습니다.
</pre>
  </div>
  <p class="policy-index" data-index="3" data-label="개인정보의 처리 및 보유기간">
    <i>4</i> 개인정보의 처리 및 보유기간
  </p>
  <div class="policy-content">
<pre>
회사는 법령에 따른 개인정보 보유․이용기간 또는 정보주체로부터 개인정보를 수집시에 동의받은 개인정보 보유∙이용기간 내에서 개인정보를 처리∙보유합니다. 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.

홈페이지 회원가입 및 관리
- 홈페이지 해지(탈퇴신청 등)시 까지 보관되며, 1년간 로그인하지 않을 경우 휴면계정으로 전환하여 분리 보관되며 분리 보관된 개인정보는 3년 경과시 파기합니다.

시즌권등록 관리
- 회원 탈퇴(탈퇴신청 및 휴먼계정 전환 후 탈퇴)시 혹은 회원이 직접 시즌권 삭제시 즉시 파기

① 전자상거래 등에서 소비자 보호에 관한 법률
- 계약 또는 청약철회 등에 관한 기록: 5년 보관
- 대금결제 및 재화 등의 공급에 관한 기록: 5년 보관
- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년 보관

② 전자금융거래법
- 전자금융에 관한 기록: 5년 보관

③ 통신비밀보호법
- 로그인 기록 : 3개월
</pre>
  </div>
  <p class="policy-index" data-index="4" data-label="개인정보 처리의 위탁">
   <i>5</i> 개인정보 처리의 위탁
  </p>
  <div class="policy-content">
<pre>
① 전남드래곤즈 홈페이지는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
② 전남드래곤즈 홈페이지는 위탁계약 체결시 개인정보 보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임 에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침 을 통하여 공개하도록 하겠습니다.

홈페이지
- 수탁업체 : ㈜플랫폼엔
- 위탁업무 : 서비스 운영
- 개인정보의 보유 및 이용기간 : 회원 탈퇴시 혹은 위탁계약 종료시까지

티켓
- 수탁업체 : 주식회사 놀유니버스
- 위탁업무 : 시즌권 및 티켓예매 및 확인, 취소
- 개인정보의 보유 및 이용기간 : 회원 탈퇴시 혹은 위탁계약 종료시까지
</pre>
  </div>
  <p class="policy-index" data-index="5" data-label="개인정보의 안전성 확보조치에 관한 사항">
   <i>6</i> 개인정보의 안전성 확보조치에 관한 사항
  </p>
  <div class="policy-content">
<pre>
전남드래곤즈 홈페이지는 귀하의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.

①귀하의 개인정보는 비밀번호에 의해 보호되며, 파일 및 전송 데이터를 암호화하거나 파일 잠금기능(Lock)을 사용하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다.
②전남드래곤즈 홈페이지는 백신프로그램을 이용하여 컴퓨터바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다. 백신프로그램은 주기적으로 업데이트되며 갑작스러운 바이러스가 출현할 경우 백신이 나오는 즉시 이를 제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다.
③전남드래곤즈 홈페이지는 암호알고리즘을 이용하여 네트워크 상의 개인정보를 안전하게 전송할 수 있는 보안장치(SSL 또는 SET)를 채택하고 있습니다.
④해킹 등에 의해 귀하의 개인정보가 유출되는 것을 방지하기 위해, 외부로부터의 침입을 차단하는 장치를 이용하고 있으며, 각 서버마다 침입탐지 시스템을 설치하여 24시간 침입을 감시하고 있습니다.
</pre>
  </div>
  <p class="policy-index" data-index="6" data-label="개인정보 자동 수집 장치의 설치∙운영 및 그 거부에 관한 사항">
   <i>7</i> 개인정보 자동 수집 장치의 설치∙운영 및 그 거부에 관한 사항
  </p>
  <div class="policy-content">
<pre>
전남드래곤즈 홈페이지는 귀하의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)'를 운용합니다. 전남드래곤즈 홈페이지가 쿠키를 통해 수집하는 귀하의 개인정보는 아이디, 페이지 뷰 현황 등에 한하며, 그 외의 다른 정보는 수집하지 않습니다. 전남드래곤즈 홈페이지가 쿠키를 통해 수집한 귀하의 개인정보는 다음과 같은 목적을 위해 사용됩니다.

전남드래곤즈 홈페이지 회원과 비회원의 접속 빈도나 방문 시간 등을 분석하고 이용자의 취향과 관심분야를 파악하여 타겟(target) 마케팅 및 서비스 개편 등의 척도로 활용합니다. 전남드래곤즈 홈페이지가 진행하는 각종 이벤트에서 귀하의 참여 정도 및 방문 횟수를 파악하여 차별적인 응모 기회를 부여하고 개인의 관심 분야에 따라 차별화된 정보를 제공하기 위한 자료로 이용됩니다.귀하는 쿠키에 대한 선택권을 가지고 있습니다. 

귀하는 웹브라우저에서 [도구] > [인터넷 옵션] > [보안] > [사용자 정의수준]을 선택함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
</pre>
  </div>
  <p class="policy-index" data-index="7" data-label="개인정보보호책임자 및 의견수렴/불만처리">
   <i>8</i> 개인정보보호책임자 및 의견수렴/불만처리
  </p>
  <div class="policy-content">
<pre>
귀하의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 전남드래곤즈 홈페이지는 개인정보관리담당자를 두어 귀하의 개인정보를 관리하고 있으며 개인정보보호와 관련하여 귀하가 의견과 불만을 제기할 수 있는 창구를 개설하고 있습니다. 귀하의 개인정보와 관련한 문의사항 및 불만 사항이 있으시면 아래의 개인정보관리담당자에게 연락 주시면 즉시 조치하여 처리결과를 통보하겠습니다.

개인정보보호 책임자
- 성명 : 송종찬
- 소속 : 대표이사
- 직책 : 대표이사
- 연락처 : (061)815-0114
- E-MAIL : dragons@dragons.co.kr

개인정보관리 책임자
- 성명 : 정용진
- 소속 : 홍보마케팅실
- 직책 : 실장
- 연락처 : (061)815-0114
- E-MAIL : dragons@dragons.co.kr

개인정보관리 담당자
- 성명 : 홍성주
- 소속 : 홍보마케팅실
- 직책 : 과장
- 연락처 : (061)815-0114
- E-MAIL : dragons@dragons.co.kr

이외 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.

※ 아래의 기관은 회사와는 별개의 기관으로서, 회사의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다.

경찰청사이버안전국
- 홈페이지 : cyberbureau.police.go.kr
- 전화 : (국번없이) 182

대검찰정 사이버범죄수사단
- 홈페이지 : www.spo.go.kr
- 전화 : 02-3480-3573

개인정보 침해신고센터(한국인터넷진흥원 운영)
- 소관업무 : 개인정보 침해사실 신고, 상담 신청
- 홈페이지 : privacy.kisa.or.kr
- 전화 : (국번없이) 118
- 주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층

개인정보 분쟁조정위원회
- 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)
- 홈페이지 : www.kopico.go.kr
- 전화 : (국번없이) 1833-6972
- 주소 : (03171)서울특별시 종로구 세종대로 209 정부서울청사 4층
</pre>
  </div>
  <p class="policy-index" data-index="8" data-label="개인정보의 파기에 관한 사항">
   <i>9</i> 개인정보의 파기에 관한 사항
  </p>
  <div class="policy-content">
<pre>
회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다. 개인정보 파기의 절차 및 방법은 다음과 같습니다.
- 파기절차 : 불필요한 개인정보 및 개인정보파일은 내부지침에 따라 다음과 같이 처리하고 있습니다.
- 개인정보의 파기 : 보유기간이 경과한 개인정보는 종료일로부터 지체 없이 파기합니다.
- 파기방법 : 전자적 파일 형태의 정보는 기록을 재생할 수 없도록 파기하며, 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
</pre>
  </div>
  <p class="policy-index" data-index="9" data-label="개인정보 처리방침의 변경">
   <i>10</i> 개인정보 처리방침의 변경
  </p>
  <div class="policy-content">
<pre>
① 이 개인정보처리방침은 2025년 12월 11일에 개정되었으며 법령/정책 또는 보안기술의 변경에 따라 내용의 추가, 삭제 및 수정이 있을 시에는 변경되는 개인정보처리방침을 시행하기 최소 10일전에 홈페이지를 통해 변경 이유 및 내용 등을 공지하도록 하겠습니다.
- 개인정보처리방침 버전번호 : v2.1
- 개인정보처리방침 시행일자 : 2025-12-11
- 개인정보처리방침 이전 버전 : v.2.0
- 개인정보처리방침 최종변경일자 : 2025-12-11

② 단, 개인정보의 제3자 제공, 수집·이용목적 변경, 보유기간 변경 등 중요한 사항이 변경되는 경우에는 이용자의 동의를 얻도록 하겠습니다.

③ 이전의 개인정보처리방침은 아래에서 확인하실 수 있습니다.
</pre>
  </div>

</div>
  `
}
